import types from "rdx/modules/mentorRatings/types";
import createAction from "rdx/utils/createAction";

export default {
  setMentorRating: (payload) => createAction(types.SET_MENTOR_RATING, payload),
  updateMentorRating: (payload) => createAction(types.UPDATE_MENTOR_RATING, payload),
  // INSERTION_PT (for script, do not remove)
};
